<template>
    <div>
        <hts-form-select
            ref="selectCooperatorInvoicingInformation"
            v-model="cValue"
            v-model:text="cText"
            :query="findCooperator"
            :filterable="true"
            :clearable="true"
            :label="label"
            :required="required"
            :selected-multiple="dataMultiple"
            :multiple="multiple"
            :prop="prop"
            :disabled="disabled"
            :readonly="readonly"
            key-id="_id"
            :key-label="keyLabel"
            :creatable="CCreatable"
            :param-prepare="paramPrepare"
            @create-new="createCooperatorInvoicingInformation"
            @change="(data) => change(data)">
            <template #default="{ item }">
                <p
                    class="align-middle"
                    :class="{ 'font-bold': keySubLabel }">
                    {{ item[keyLabel] || $t('labels.invalidData') }}
                </p>
                <p
                    v-if="keySubLabel"
                    class="align-middle font-light">
                    {{ item[keySubLabel] || '' }}
                </p>
            </template>
        </hts-form-select>

        <AddCooperatorInvoicingInformation
            ref="addCooperatorInvoicingInformation"
            @newData="handleChangeNewData" />
    </div>
</template>

<script lang="ts" setup>
import { checkPermission } from '@/utils/permission-check'
import layoutPermissions from '~/data/permissions/layout-permissions'
import AddCooperatorInvoicingInformation from '../../pages/trucker-[id]/partner/[idpartner]/invoicing-information/-components/add.vue'

const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  prop: { type: String, default: '' },
  multiple: { type: Boolean, default: false },
  dataMultiple: { type: [Array, Object], default: () => [] },
  required: { type: Boolean, default: false },
  name: { type: String, default: '' },
  label: { type: String, default: () => $t('labels.partnerInvoicingInformationFind') },
  cooperatorId: { type: String, required: true },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  type: { type: String, default: '' },
  creatable: { type: Boolean, default: false },
  paramPrepare: { type: String, default: '' },
  keyLabel: { type: String, default: 'companyName' },
  keySubLabel: { type: String, default: '' }
})

const emits = defineEmits(['update:modelValue', 'update:name', 'click', 'change'])

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const { modelValue, name, required, multiple, cooperatorId, creatable, keyLabel, disabled, type } = toRefs(props)

const addCooperatorInvoicingInformation = ref()
const selectCooperatorInvoicingInformation = ref()

const CCreatable = computed(() => {
  if (!creatable?.value) {
    return false
  }
  // if (!checkPermission(layoutPermissions.partner_invoicing_information_add)) {
  //   return false
  // }
  return true
})

const availableTypes = computed(() => {
  if (typeof type.value === 'string') {
    return [type.value]
  }
  return type.value
})

const createCooperatorInvoicingInformation = () => {
  if (!creatable?.value) {
    return null
  }

  if (!cooperatorId?.value) {
    return null
  }

  if (!checkPermission(layoutPermissions.partner_add)) {
    process.client && $toast().error($t('labels.vendorPriceModule.invoicingInformationNotPermission'))
    return null
  }

  if (addCooperatorInvoicingInformation.value) {
    if (selectCooperatorInvoicingInformation.value) {
      selectCooperatorInvoicingInformation.value.hide()
    }

    addCooperatorInvoicingInformation.value.open(cooperatorId.value)
  }
}

const findCooperator = async (s: string) => {
  if (disabled.value) {
    return
  }

  if (!cooperatorId.value) {
    return null
  }

  const api = {
    url: '/partner/invoicing-information/COOPERATOR/find',
    method: 'get'
  }

  const res = await $api(api, { uriParams: { COOPERATOR: cooperatorId.value }, query: { key: s, type: availableTypes.value || '' } })
  const resData: any = res?.data.value

  if (resData?.success) {
    return resData.data
  }
  return null
}
const cText = computed({
  get () {
    return name.value || ''
  },
  set (val: any) {
    console.log('444')
    emits('update:name', val)
  }
})

const change = (data: any) => {
  emits('change', data)
}
watch(
  () => cooperatorId.value,
  () => {
    emits('update:modelValue', '')
    emits('change', [])
  }
)

const handleChangeNewData = (data: any) => {
  if (!multiple.value) {
    if (type.value && data.department !== type.value) {
      return
    }

    if (data && data._id) {
      cValue.value = data._id || ''
      cText.value = data[keyLabel.value] || ''
    }
    change([data])
  }
}
</script>
